import { createServerFn } from "@tanstack/react-start"

import { getSessionUser } from "../session.server"
import { getUserById } from "../user.server"

export type UserData = {
  user: { id: string; email: string; name: string | null; roles: string[] } | null
}

export const getUser = createServerFn({ method: "GET" }).handler(async () => {
  const sessionUser = await getSessionUser()
  if (!sessionUser) {
    return { user: null } satisfies UserData
  }

  const profile = await getUserById(sessionUser.id)
  return {
    user: {
      id: sessionUser.id,
      email: sessionUser.email,
      name: profile?.displayName ?? null,
      roles: profile?.roles ?? [],
    },
  } satisfies UserData
})
